/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_Give_3Inputs */

const en_cp_lead_give_3 = /** @type {(inputs: Cp_Lead_Give_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A short report and product feedback`)
};

const id_cp_lead_give_3 = /** @type {(inputs: Cp_Lead_Give_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporan singkat dan feedback produk`)
};

/**
* | output |
* | --- |
* | "A short report and product feedback" |
*
* @param {Cp_Lead_Give_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_give_3 = /** @type {((inputs?: Cp_Lead_Give_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_Give_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_give_3(inputs)
	return en_cp_lead_give_3(inputs)
});